/* EVENTS INVOLVING ViewFilters on client*/

module.exports = {
  filter_view_save_initiated: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, filterNums }) => {
      return {
        dashboard_id: dashboard.id,
        dashboard_name: dashboard.name,
        total_filter_count: filterNums,
      };
    },
  },
  filter_view_update_initiated: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, filterNums, view }) => {
      return {
        dashboard_id: dashboard.id,
        dashboard_name: dashboard.name,
        total_filter_count: filterNums,
        view_id: view.id,
        view_name: view.name,
      };
    },
  },
  all_active_filters_removed: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, view }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        view_id: view?.id,
        view_name: view?.name,
      };
    },
  },
  active_filter_removed: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, deletedFilter }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        filter: deletedFilter,
      };
    },
  },
  filter_widget_assignment_updated: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, editingView }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        view_id: editingView?.id,
        view_name: editingView?.name,
      };
    },
  },
  filter_view_applied: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, view, activeFiltersInView }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        view_id: view?.id,
        view_name: view?.name,
        total_filter_count: Object.keys(activeFiltersInView).length,
        total_filters_associated_to_widgets_count: Object.values(
          activeFiltersInView
        )
          .map((filter) => filter.widgetIds.length)
          .reduce((a, b) => a + b, 0),
      };
    },
  },
  max_filter_limit_reached_warning: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, maxFilterLimit }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        limit_value: maxFilterLimit,
      };
    },
  },
  last_widget_deletion_confirmed: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, brokenFilters }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        broken_filter_count: brokenFilters,
      };
    },
  },
  filter_error_displayed: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, errorType, dataTable, affectedFilterIds }) => {
      return {
        dashboard_id: dashboard?.id,
        dashboard_name: dashboard?.title,
        errorType: errorType,
        dataTable_name: dataTable?.name,
        integration: dataTable?.integration ? dataTable?.integration : dataTable?.integrationname,
        affected_filter_count: affectedFilterIds?.length,
      };
    },
  },
};
